import { useMemo } from 'react';

import { useCheckout } from '../../../../../hooks/use-checkout';
import { usePaymentState } from '../../../hooks/use-payment-state';

export function useFooterText() {
  const { checkoutData } = useCheckout();
  const customerGeoState = usePaymentState((state) => state.customerGeoState);

  const countryCode =
    checkoutData?.customer.taxCountry || checkoutData?.customer.geoLocator.countryCode2;
  const footerConfiguration = checkoutData?.checkoutConfigurations.footerConfiguration;

  const decodedRichtext = useMemo(() => {
    if (customerGeoState && countryCode === 'US') {
      const stateRichText =
        footerConfiguration?.fullFooterConfig?.[countryCode as string]?.[customerGeoState as string]
          ?.richText;

      return atob(stateRichText || footerConfiguration?.defaultText || '');
    }
    return atob(footerConfiguration?.footerText || '');
  }, [footerConfiguration, countryCode, customerGeoState]);

  return {
    footerText: decodedRichtext,
  };
}
